<template>
  <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100 dark:border-gray-700 flex-shrink-0">
    <div class="flex items-center gap-2">
      <button
        @click="emit('close')"
        class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
        aria-label="Close"
      >
        <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
      <h2 class="text-base font-semibold text-gray-900 dark:text-white">{{ title }}</h2>
    </div>

    <button
      @click="emit('save')"
      :disabled="saving"
      class="px-4 py-1.5 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm font-semibold rounded-full transition-colors flex items-center gap-1.5"
    >
      <svg v-if="saving" class="w-3.5 h-3.5 animate-spin" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
      </svg>
      {{ saving ? 'Saving...' : 'Save' }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  title:  { type: String,  default: 'New Booking' },
  saving: { type: Boolean, default: false },
})
const emit = defineEmits(['close', 'save'])
</script>
